import { binaryToHex, hexToBinary } from './binaryUtils';
import { PREFIXED_STRING_LENGTH } from './EthereumAddress';
const REGEX = /^0x[a-fA-F0-9]+$/;
export const toUserId = (input) => {
    if (input instanceof Uint8Array) {
        return binaryToHex(input, true);
    }
    else {
        if (isValidUserId(input)) {
            return input.toLowerCase();
        }
        throw new Error(`not a valid UserID: "${input}"`);
    }
};
export const toUserIdRaw = (userId) => {
    return hexToBinary(userId);
};
export const isValidUserId = (input) => {
    return REGEX.test(input);
};
export const isEthereumAddressUserId = (userId) => {
    return userId.length === PREFIXED_STRING_LENGTH;
};
//# sourceMappingURL=UserID.js.map